// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQueryWithOffset } from '@hooks/other/useQueryWithOffset';
import { UseQueryResult } from '@tanstack/react-query';
import { UserServiceRequest } from '@daml.js/utility-collateral-app-v2/lib/Utility/Collateral/App/Service/User';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useOperatorParty } from '../../utility-operator/useOperatorParty';

export const useUserServiceRequestsV2: () => UseQueryResult<
  TemplateContract<UserServiceRequest>[],
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  const operator = useOperatorParty()?.data;

  return useQueryWithOffset({
    enabled: !!operator,
    queryKey: ['queryCollateralUserServiceRequestsV2', operator],
    queryFn: async (_, offset) => {
      if (!operator) {
        return Promise.resolve([]);
      }
      return ledgerApi.queryCollateralUserServiceRequestsV2(offset, operator);
    },
  });
};
